export default function(callback) {
    let firstRun = true;
    document.addEventListener("readystatechange", event => {
        if (firstRun) {
            if (typeof callback == "function") {
                callback(event);
            }
            firstRun = false;
        }
    });
}
